import type { FileError, FileWithPath } from "react-dropzone";
import AcceptedFile from "./acceptedFile";
import { getErrorMessage, getIcon } from "./helper";

interface IProps {
  acceptedFiles: (FileWithPath & { status: number })[];
  rejectedFiles: { file: File; errors: FileError[] }[];
  handleRemoveFile: (string: string) => void;
  isRemoveEnabled: boolean;
  errorId: string;
}

const List = (props: IProps) => {
  const {
    acceptedFiles,
    rejectedFiles,
    handleRemoveFile,
    isRemoveEnabled,
    errorId,
  } = props;

  const renderAcceptedFiles = () => {
    return acceptedFiles.map((file, index) => (
      <AcceptedFile
        key={index}
        file={file}
        isRemoveEnabled={isRemoveEnabled}
        handleRemoveFile={handleRemoveFile}
        errorId={errorId}
      />
    ));
  };

  return (
    <div role="list" className="flex-wrap divide-y divide-gray-300">
      <div>{renderAcceptedFiles()}</div>
      {rejectedFiles.map(({ file, errors }) => (
        <div
          key={file.name}
          className="flex items-center justify-between gap-x-6 py-1"
        >
          <div className="flex min-w-0 gap-x-4">
            <img
              height={48}
              width={48}
              className="size-12 flex-none rounded-md"
              src={getIcon(file.type)}
              alt="file icon"
            />
            <div className="min-w-0 flex-auto">
              <p className="truncate text-sm font-semibold leading-6 text-gray-900">
                {file.name}
              </p>
              {errors.map((e: { code: any }, i: number) => (
                <p
                  key={i}
                  className="mt-1 truncate text-xs leading-5 text-red-500"
                >
                  {getErrorMessage(e.code)}
                </p>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default List;
